import React, { useEffect } from 'react';

// Components
import { Layout } from '../../components/Layout';
import { Heading } from '../../components/Heading';
import { PartyLogo } from '../../components/PartyLogo';

// i18n
import { useTranslation } from '../../translations/useTranslation';
import { useForm } from '../../context/form-context/hooks';

// Utils
import { gtmGA4Event } from '../../utilities/gtm';

export const CompleteView: React.FC = () => {
  const { state } = useForm();
  const { locale } = useTranslation();

  useEffect(() => {
    if (state.formMode === 'eId') {
      if (state.typeOfNewMember === 'automatic') {
        gtmGA4Event('application-auto');
      } else if (state.typeOfNewMember === 'manually') {
        gtmGA4Event('application-manual');
      }
    } else {
      gtmGA4Event('application-no-eid');
    }
  }, [state.typeOfNewMember]);

  // If new member is automatic and swedish is our locale
  if (state.typeOfNewMember === 'automatic' && locale === 'sv-SE') {
    return (
      <Layout viewId={'complete complete--automatic'}>
        <div className="membership-app__complete-header-wrapper">
          <PartyLogo className="membership-app__complete-icon" />
          <Heading size="large">
            Du är nu arbetslöshetsförsäkrad i Sveriges största a-kassa.
          </Heading>
        </div>
        <p>
          Beslut och information har vi skickat per mejl. Logga in i{' '}
          <a
            href="https://medlem.akademikernasakassa.se/"
            title="Mitt medlemskap"
          >
            Mitt medlemskap
          </a>{' '}
          för att kontrollera eller ändra dina uppgifter.
        </p>
        <p>
          <a
            href="http://www.akademikernasakassa.se/regler"
            title="Regler och villkor i din försäkring"
          >
            Regler och villkor i din försäkring
          </a>
        </p>
        <p>Du kan nu stänga det här fönstret.</p>
      </Layout>
    );
  }

  // If new member is automatic and english is our locale
  if (state.typeOfNewMember === 'automatic' && locale === 'en-US') {
    return (
      <Layout viewId={'complete complete--automatic'}>
        <div className="membership-app__complete-header-wrapper">
          <PartyLogo className="membership-app__complete-icon" />
          <Heading size="large">
            You are now a member of Sweden's biggest a-kassa.
          </Heading>
        </div>
        <p>
          We have sent you an email with our formal decision, as well as some
          information about your membership. Log in to{' '}
          <a
            href="https://medlem.akademikernasakassa.se/"
            title="Mitt medlemskap"
          >
            Mitt medlemskap
          </a>{' '}
          to check or update your details.
        </p>
        <p>
          <a
            href="http://www.akademikernasakassa.se/regler"
            title="The rules and terms of unemployment insurance."
          >
            The rules and terms of unemployment insurance.
          </a>
        </p>
        <p>You may close this window now.</p>
      </Layout>
    );
  }

  // If new member is manually and english is our locale
  if (state.typeOfNewMember === 'manually' && locale === 'en-US') {
    return (
      <Layout viewId={'complete complete--manually'}>
        <div className="membership-app__complete-header-wrapper">
        <svg className="membership-app__complete-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm3.536-12.95 1.414 1.414-4.95 4.95L10.586 12l4.95-4.95z" />
        </svg>
          <Heading size={'large'}>
            Thank your for applying to join <br />
            Akademikernas a-kassa
          </Heading>
        </div>
        <p>
          One of our case workers will contact you with our decision. We aim to
          give you our decision within three working days. Most of the time you
          can expect a quicker response.
        </p>
        <p>You may close this window now.</p>
      </Layout>
    );
  }

  // For any other scenario
  return (
    <Layout viewId={'complete complete--manually'}>
      <div className="membership-app__complete-header-wrapper">
        <svg className="membership-app__complete-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill="none" d="M0 0h24v24H0z" />
          <path d="M12 2c5.52 0 10 4.48 10 10s-4.48 10-10 10S2 17.52 2 12 6.48 2 12 2zm0 18c4.42 0 8-3.58 8-8s-3.58-8-8-8-8 3.58-8 8 3.58 8 8 8zm3.536-12.95 1.414 1.414-4.95 4.95L10.586 12l4.95-4.95z" />
        </svg>
        <Heading size={'large'}>
          Tack för din ansökan till <br />
          Akademikernas a-kassa
        </Heading>
      </div>
      <p>
        En handläggare kommer nu att fatta beslut i ditt ärende och vårt mål är
        att du ska få besked inom tre arbetsdagar. Oftast går det snabbare. Vi
        hör av oss snart.
      </p>
      <p>Du kan nu stänga det här fönstret.</p>
    </Layout>
  );
};
